import { render, staticRenderFns } from "./CandidateLanguageInfo_1.vue?vue&type=template&id=ce5c91cc"
import script from "./CandidateLanguageInfo_1.vue?vue&type=script&lang=js"
export * from "./CandidateLanguageInfo_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports